import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import { PARTNER_PATHS } from "./paths";
import {
  IHubPartnerCreateRequest,
  IHubPartnerUpdateRequest,
  PartnerListRequest,
  PartnerDetailResponse,
  PartnerSettingListRequest,
  PartnerSettingDetailResponse,
  IHubPartnerSettingCreateRequest,
  IHubPartnerSettingUpdateRequest,
} from "./types";

/**
 * List
 */
export const partnerListService = (params: PartnerListRequest) =>
  RestAPIClient.call<{ items: PartnerDetailResponse[]; total: number }>({
    method: HTTPRequestMethods.GET,
    url: PARTNER_PATHS.LIST,
    config: {
      params,
      requireAuthentication: true,
    },
  });

/**
 * Detail
 */
export const partnerDetailService = (id: string) =>
  RestAPIClient.call<PartnerDetailResponse>({
    method: HTTPRequestMethods.GET,
    url: PARTNER_PATHS.DETAIL.replace(":id", id),
    config: {
      requireAuthentication: true,
    },
  });

/**
 * Create
 */
export const partnerCreateService = (data: IHubPartnerCreateRequest) =>
  RestAPIClient.call<PartnerDetailResponse>({
    method: HTTPRequestMethods.POST,
    url: PARTNER_PATHS.CREATE,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Update
 */
export const partnerUpdateService = (data: IHubPartnerUpdateRequest) =>
  RestAPIClient.call<PartnerDetailResponse>({
    method: HTTPRequestMethods.PUT,
    url: PARTNER_PATHS.UPDATE.replace(":id", data.id),
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * List Settings
 */
export const partnerSettingListService = (params: PartnerSettingListRequest) =>
  RestAPIClient.call<{ items: PartnerSettingDetailResponse[]; total: number }>({
    method: HTTPRequestMethods.GET,
    url: PARTNER_PATHS.SETTING_LIST.replace(":partnerId", params.partnerId),
    config: {
      params,
      requireAuthentication: true,
    },
  });

/**
 * Detail Setting
 */
export const partnerSettingDetailService = ({
  partnerId,
  id,
}: {
  partnerId: string;
  id: string;
}) =>
  RestAPIClient.call<PartnerSettingDetailResponse>({
    method: HTTPRequestMethods.GET,
    url: PARTNER_PATHS.SETTING_DETAIL.replace(":partnerId", partnerId).replace(
      ":id",
      id
    ),
    config: {
      requireAuthentication: true,
    },
  });

/**
 * Create Setting
 */
export const partnerSettingCreateService = ({
  partnerId,
  data,
}: {
  partnerId: string;
  data: IHubPartnerSettingCreateRequest;
}) =>
  RestAPIClient.call<PartnerSettingDetailResponse>({
    method: HTTPRequestMethods.POST,
    url: PARTNER_PATHS.SETTING_CREATE.replace(":partnerId", partnerId),
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Update Setting
 */
export const partnerSettingUpdateService = ({
  partnerId,
  data,
}: {
  partnerId: string;
  data: IHubPartnerSettingUpdateRequest;
}) =>
  RestAPIClient.call<PartnerSettingDetailResponse>({
    method: HTTPRequestMethods.PUT,
    url: PARTNER_PATHS.SETTING_UPDATE.replace(":partnerId", partnerId).replace(
      ":id",
      data.id
    ),
    config: {
      requireAuthentication: true,
    },
    data,
  });
